import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type Response = paths['/api/lux-loyalty/customer/{customerId}/enrolment-tier']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyAccountEligibility(customerId: string) {
  const response = await requestUtils.get<Response>(`/api/lux-loyalty/customer/${customerId}/enrolment-tier`, {
    credentials: 'include',
  })

  return response.result.enrolmentTier
}

export default requestLoyaltyAccountEligibility
